import { inject, InjectionToken } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { WindowWithGoogleAnalytics } from '@cpak/consts';

export const WINDOW = new InjectionToken<WindowWithGoogleAnalytics>('Window Object', {
  factory: () => {
    const { defaultView } = inject(DOCUMENT);

    if (!defaultView) {
      throw new Error('Window is not available');
    }

    return defaultView;
  },
});
